import { portalApi } from '../../../store/generated/portal/chat/copilot';

const ChatApiTags = {
  Threads: 'Threads',
};

const copilotApi = portalApi.enhanceEndpoints({
  addTagTypes: [ChatApiTags.Threads],
  endpoints: {
    apiPortalV1ChatCopilotCreate: {
      invalidatesTags: [ChatApiTags.Threads],
    },
    apiPortalV1ChatCopilotList: {
      providesTags: [ChatApiTags.Threads],
    },
    apiPortalV1ChatCopilotDestroy: {
      invalidatesTags: [ChatApiTags.Threads],
    },
  },
});

export { copilotApi };
